import { AppState } from '../store';

export const budgetsSelector = (state: AppState) => state.budgetsReducer;
